import useNotifications from '../../hooks/useNotifications';

const NotificationDisplay = () => {
  useNotifications();
  return <></>
}

export default NotificationDisplay;
